const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/AppointmentCards/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        currentAppointment: 'Laufender Termin',
        nextAppointment: 'Nächster Termin',
        noAppointmentWithEmailLoginSubtitle: 'Keine Termine vorhanden',
        noAppointmentText: 'Buchen Sie jetzt einen Termin oder besuchen Sie unsere Website {hospitalName}',
        cardTitleAppointment: 'Alle Termine',
    },
    __RELATIVE_SOURCE_FILE__
);
